import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { slice_ui } from '@/state/ui/slice_ui';
import { UTILS__generation } from '@/utils/UTILS__generation';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { DTO__image_size } from '@shared/dto/+image/image_asset_base/DTO__image_size';
import { FN_INVOCATION__create_manually_by_type } from '@shared/dto/generation/graph_invoke/_invocations/_base/FN_INVOCATION__create_manually_by_type';
import { useReactFlow } from '@xyflow/react';

interface PROPS {
  div_container: HTMLDivElement;
  container_size: DTO__image_size;
}

export function WATCHER__xyflow_drop_node_invocation({ div_container, container_size }: PROPS) {
  const dispatch = use_dispatch();
  const { g_dragging_invocation_type } = use_slice_ui(['g_dragging_invocation_type']);
  const { generation_current } = use_slice_generation(['generation_current']);

  const { screenToFlowPosition } = useReactFlow();

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (container_size.is_zero()) return;

    div_container.addEventListener('dragover', onDragOver);
    div_container.addEventListener('drop', onDrop);

    return () => {
      div_container.removeEventListener('dragover', onDragOver);
      div_container.removeEventListener('drop', onDrop);
    };
  }, [div_container, g_dragging_invocation_type, generation_current, container_size, onDragOver, onDrop]); // Dependencies

  /*
   * EVENTS
   */
  function onDragOver(e: DragEvent) {
    e.preventDefault();
  }

  async function onDrop(e: DragEvent) {
    e.preventDefault();

    if (g_dragging_invocation_type == '') return;

    const type = g_dragging_invocation_type;

    const position = screenToFlowPosition({ x: e.clientX, y: e.clientY });

    const grid_size = CONSTANTS__shared.GRID_CELL_SIZE;
    const x = Math.round(position.x / grid_size) * grid_size;
    const y = Math.round(position.y / grid_size) * grid_size;

    let graph_new = generation_current.tool.graph.clone();

    const node = FN_INVOCATION__create_manually_by_type(type, graph_new);
    [node.meta.graph_x_px, node.meta.graph_y_px] = [x, y];

    graph_new.values_allowed__fill();

    await UTILS__graph_data.update(graph_new);

    await UTILS__generation.update_tool_name_as_custom(generation_current.tool);

    dispatch(slice_ui.actions.set_string({ value: '', key: 'g_dragging_invocation_type', valid_values: [] }));
  }

  /*
   * HTML
   */
  return null;
}
